import { User } from "interfaces/user";
import { createContext } from "react";

export const UserContext = createContext<User>({} as User);
